<!--
Displays a UoG logo banner.
Usage: <Logo />
@author bmk11u, crm4f
-->
<template>
  <header>
    <div class="headerContainer" :style="{ 'background-color': bannerColour }">
      <div id="logo" style="width:50%" :style="{ 'background-color': bannerColour }">
        <img src="@/assets/UofG_App_Logo.svg" id="marque" alt="University of Glasgow Logo" height="110px"/>
      </div>
      <div class="notiContainer">
        <span v-if="props.showNotif" v-on:click="go('/notifications')" id="notiSpan">
          <img v-if="props.unreadNum!=0" id="bellNotiImg" src="@/assets/noti-bell.svg" alt="Notifications - unread notifications"/>
          <img v-else id="bellImg" src="@/assets/bell.svg" alt="Notifications - no unread notifications"/>
        </span>
        <p id="welcome" v-if="props.showWelcome">Welcome, {{ props.name }}</p>
      </div>
    </div>
  </header>
</template>

<script setup>
import * as lst from '@/components/localStorage.js'
import axios from 'axios'
import { onMounted, ref, defineProps} from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()
const props = defineProps(['unreadNum', 'showNotif', 'showWelcome', 'name'])

/* these values were present in the old options API component? they're not used? 
const hasBookingAccess = ref(lst.getValue('hasBookingAccess'))
const showPopupStudySpace = ref(lst.getValue('showPopupStudySpace'))
const hasChanges = ref(lst.getValue('hasChanges'))
*/
const authenticated = ref(lst.getValue('authenticated'))

const bannerColour = ref('#003865')
const currentAppTheme = ref(1)

onMounted(() => {
  // but don't do this if we're called in an unauthenticated context plz
  if (isTrue(authenticated.value)) {
    getCurrentAppTheme()
  }
})

function isTrue(val) {
  let ret = false
  if (val == true || val == 'true') {
    ret = true
  }
  return ret
}

function getCurrentAppTheme() {
  axios.get('/timetable/banners/category/42', {})
    .then(response => {
      // get the app-wide theme id
      let banners = response.data.banners
      if (typeof banners !== 'undefined' && banners.length > 0) {
        currentAppTheme.value = banners[0].content
        getBannerColour()
      }
    })
    .catch((error) => {
      console.log(error)
    })
}

function getBannerColour () {
  axios.get('/timetable/theme/element/' + currentAppTheme.value + '/colour', {})
    .then(response => {
      // take one banner and display it
      let colour = response.data
      if (colour == "") {
        bannerColour.value = "#003865"
      } else {
        bannerColour.value = colour.elementValue
      }
    })
    .catch((error) => {
      console.log(error)
    })
}

function go (path) {
  router.push(path)
}
</script>

<style scoped lang="scss">
.headerContainer {
  display: flex;
  /* Status bar height on iOS 11.0 */
  padding-top: constant(safe-area-inset-top);
  /* Status bar height on iOS 11+ */
  padding-top: env(safe-area-inset-top);
}

.notiContainer {
  padding-right: 15px;
  margin: 3px;
  width: 50%;
  display: flex;
  flex-flow: column wrap;
  justify-content: flex-end;
}

#notiSpan {
  float: right;
  text-align: end;
  margin-bottom: 20px;
  margin-left: 20px;
  margin-top: 40px;
}

#p {
  float:left;
}

#logo {
  height: 130px;
  /* Status bar height on iOS 10 */
  padding-top: 20px;
  position: relative;
  bottom: 0;
}

#marque {
  /*padding: 25px 0 25px 25px;*/
  width: 110px;
  height: auto;
 padding: 0;
 position: absolute;
 bottom: 0;
 /*svg */
  width: 110px;
  height: 110px;
  padding: 10px 29px;
}

#welcome {
  text-align:right;
  color:white;
  margin-bottom: 3px !important;
  font-weight: bold;
}

#bellImg {
  width: 20px;
  height: 23px;
  cursor: pointer;
}

#bellNotiImg {
  width: 23px;
  height: 28px;
  cursor: pointer;
}

</style>
